module.exports = __webpack_public_path__ + "static/media/Spin-1s-58px.b6c76d43.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Spin-1s-58px.gif
// module id = 16
// module chunks = 0